import $ from 'jquery';

  export default function(){
    // Redirects should be handled by the app directly. 
    $(document).ajaxComplete(function(event, xhr) {
        if (xhr && xhr.responseJSON && xhr.responseJSON.redirect) {
            window.location = xhr.responseJSON.redirect;
        }
        if (xhr && xhr.status === 403) {
          if (xhr.responseJSON && xhr.responseJSON.error) {
            var errString = xhr.responseJSON.error;
            console.warn(errString);
          }
        }
    }); 
  }

